import { useMemo } from 'react';
import moment from 'moment';
import MantineTable from '../../../common/table/mantine';
import { Text } from '@mantine/core';
import { routes } from '../../../routes';
import { Link } from 'react-router-dom';

const Table = ({ requests, loading }) => {
  const columns = useMemo(
    () => [
      {
        accessorKey: 'request_id',
        header: 'Ext. ID',
        Cell: ({
          row: {
            original: { request_id },
          },
        }) => {
          return (
            <Link to={routes.extensions(request_id).info}>
              <Text>{request_id}</Text>
            </Link>
          );
        },
      },
      {
        accessorKey: 'material',
        header: 'SKU',
      },
      {
        accessorKey: 'material_description',
        header: 'SKU Description',
      },
      {
        accessorKey: 'type',
        header: 'Extension type',
      },
      {
        accessorKey: 'sales_org',
        header: 'Sales Org',
      },
      {
        accessorKey: 'country',
        header: 'Country',
      },
      {
        accessorKey: 'requester',
        header: 'Requester',
      },
      {
        accessorKey: 'submitted_on',
        header: 'Submitted On',
      },
    ],
    [requests],
  );

  return (
    <>
      <MantineTable
        columns={columns}
        initialData={requests}
        initialState={{
          sorting: [
            {
              id: 'submitted_on',
              desc: true,
            },
          ],
        }}
        enableRowSelection={false}
        loading={loading}
        showSelectedToggle={false}
        hideSelectColumn={true}
        showResetAll={false}
        pageSize={10}
        enableColumnFilter={false}
        enableFilters={false}
        enableExport={true}
        columnFilterDisplayMode={false}
        csvFilename={`Extensions_${moment().format('YYYY-MM-DD')}`}
      />
    </>
  );
};

export default Table;
